{
    "(None)": "",
    "(save {highestYearlyDiscount}%)": "({highestYearlyDiscount}%オフ)",
    "{amount} days free": "{amount}日間無料",
    "{amount} off": "{amount}オフ",
    "{amount} off for first {number} months.": "最初の{number}ヶ月間{amount}オフ",
    "{amount} off for first {period}.": "最初の{period}{amount}オフ",
    "{amount} off forever.": "永久に{amount}オフ",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% 割引",
    "{duration} membership": "",
    "{field}: {message}": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail}は{newsletterName}のニュースレターを受信しなくなります。",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "誰かがあなたのコメントに返信しても、{memberEmail} はメールを受信しません。",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} はこのニュースレターを受信しなくなります。",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays}日間無料",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "アカウント",
    "Account details updated successfully": "アカウント詳細が更新されました",
    "Account settings": "アカウント設定",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "Address line 1": "",
    "Address line 2": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "無料期間が終了すると、選択したプランの通常価格が請求されます。それまではいつでもキャンセルできます。",
    "Already a member?": "すでに会員ですか？",
    "An error occurred": "エラーが発生しました",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "予期しないエラーが発生しました。もう一度試すか、エラーが解決しない場合は<a>サポートにお問い合わせ</a>ください。",
    "Back": "戻る",
    "Back to Log in": "ログインに戻る",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "ブラックフライデー",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "いつでもキャンセル可能",
    "Cancel subscription": "購読をキャンセル",
    "Canceled": "",
    "Cancellation reason": "キャンセル理由",
    "Change": "変更",
    "Change plan": "プラン変更",
    "Check spam & promotions folders": "スパムとプロモーションフォルダを確認してください",
    "Check with your mail provider": "メールプロバイダーに確認してください",
    "Check your inbox to verify email update": "",
    "Choose": "選択",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "別のプランを選択",
    "Choose a plan": "プランを選択",
    "Choose a tier": "",
    "Choose an option": "",
    "Choose your newsletters": "ニュースレターを選択",
    "City": "",
    "Click here to retry": "再試行するにはここをクリックしてください",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "閉じる",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "コメント",
    "Complimentary": "無料",
    "Confirm": "確認",
    "Confirm cancellation": "キャンセルを確認",
    "Confirm subscription": "購読を確認",
    "Contact support": "サポートに連絡",
    "Continue": "続ける",
    "Continue subscription": "購読を続ける",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Stripeチェックアウトセッションを作成できませんでした。",
    "Could not sign in. Login link expired.": "ログインできませんでした。ログインリンクの有効期限が切れています。",
    "Could not update email! Invalid link.": "メールアドレスを更新できませんでした。無効なリンクです。",
    "Country": "",
    "Create a new contact": "新しい連絡先を作成",
    "Current plan": "現在のプラン",
    "Delete account": "アカウントを削除",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "意図しなかった場合は、<button>こちら</button>で設定を変更してください。",
    "Don't have an account?": "アカウントをお持ちでない場合",
    "Edit": "編集",
    "Email": "メール",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "ニュースレターのメール",
    "Email newsletter settings updated": "ニュースレターの設定が更新されました",
    "Email preferences": "メールの設定",
    "Email preferences updated.": "",
    "Emails": "メール",
    "Emails disabled": "メールが無効になっています",
    "Ends {offerEndDate}": "{offerEndDate}まで",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "メールアドレスを入力してください",
    "Enter your name": "お名前を入力してください。",
    "Error": "エラー",
    "Expires {expiryDate}": "{expiryDate}まで有効",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "永久",
    "Free Trial – Ends {trialEnd}": "無料期間 - {trialEnd}まで",
    "From": "",
    "Get help": "サポート",
    "Get in touch for help": "サポートが必要な場合はご連絡ください",
    "Get notified when someone replies to your comment": "誰かがあなたのコメントに返信したときに通知を受ける",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "この投稿にフィードバックを提供する",
    "Help! I'm not receiving emails": "助けてください！メールが受信できません",
    "Here are a few other sites you may enjoy.": "他にも楽しめるサイトをいくつか次に紹介します。",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "ニュースレターがスパムとして判定された場合、そのアドレスではメールが自動的に無効になり、望ましくないメッセージを受け取らないようになります。",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "スパムの判定が誤っていた場合、またはメールの受信を再開したい場合は、前の画面のボタンをクリックしてメールを再購読することができます。",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "今すぐ購読をキャンセルすると、{periodEnd}までアクセスできます。",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "企業または政府のメールアカウントをお持ちの場合は、IT部門に連絡し、{senderEmail}からのメール受信を許可してもらってください",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "ログインリンクが受信箱に送信されました。3分以内にメールが届かない場合は、迷惑メールのフォルダーをご確認ください。",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "再度メールを受け取りたい場合は、メールアドレスに問題がないかをまず確認し、次に前の画面で再購読を選択してください。",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "購読したニュースレターのメールを受け取れてない場合は、以下の点を確認してみてください。",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "これらの項目を全て満たしてもメールがまだ受け取れない場合は、{supportAddress}に連絡してサポートを受けてください。",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "ニュースレターの送信時に永続的な障害が発生した場合、アカウントのメールが無効になります。",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "メールクライアントで{senderEmail}を連絡先リストに追加してください。これにより、メールプロバイダーにこのアドレスから送信されたメールを信頼するように伝えることができます。",
    "Invalid email address": "メールアドレスが無効です",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "興味なし",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "メールがスパムまたはプロモーションフォルダに誤って入っていないか確認してください。もしそうなら、\"スパムではない\"とマークするか、\"受信トレイに移動\"を選択してください。",
    "Manage": "管理",
    "Maybe later": "たぶん後で",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "メンバーシップが利用できません。アクセスについては管理者に連絡してください。",
    "month": "",
    "Monthly": "月額",
    "More like this": "興味あり",
    "More options": "",
    "Name": "名前",
    "Need more help? Contact support": "サポートが必要ですか？お問い合わせください。",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "ニュースレターは、2つの理由によってアカウント上で無効になる場合があります: 以前のメールがスパムとしてマークされた場合、またはメールの送信が永続的な障害によって失敗した場合です。",
    "No member exists with this e-mail address.": "このメールアドレスを持つメンバーはいません。",
    "No options found": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "メールが受信されない場合",
    "Now": "",
    "Now check your email!": "メールを確認してください",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "再購読した後も受信トレイにメールが表示されない場合は、スパムフォルダを確認してください。一部の受信トレイは以前のスパムの記録を保持し、引き続きメールを判定します。これが起こった場合は、最新のニュースレターを「スパムではない」とマークし、受信トレイに移動してください。",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "永続的な障害",
    "Phone number": "電話番号",
    "Plan": "プラン",
    "Plan checkout was cancelled.": "プランのチェックアウトがキャンセルされました。",
    "Plan upgrade was cancelled.": "プランのアップグレードがキャンセルされました。",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "無料購読を調整するためには、{supportAddress}に連絡してください。",
    "Please enter {fieldName}": "{fieldName}を入力してください",
    "Please fill in required fields": "必須項目に入力してください",
    "Podcasts": "",
    "Postal code": "",
    "Re-enable emails": "メールを再有効化する",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "おすすめ",
    "Redeem your gift": "",
    "Redeeming...": "",
    "Remove {option}": "",
    "Renews at {price}.": "{price}で更新されます。",
    "Resume subscription": "",
    "Retry": "再試行",
    "Save": "保存",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Security verification": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "ログイン先リンクを送信しています...",
    "Sending...": "送信しています...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "すべてを表示",
    "Sign in": "ログイン",
    "Sign out": "ログアウト",
    "Sign up": "新規登録",
    "Signup error: Invalid link": "エラー： 無効なリンク",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "申し訳ありませんが、うまくいきませんでした。",
    "Spam complaints": "スパムに関する苦情",
    "Start {amount}-day free trial": "{amount}日間の無料トライアルを開始する",
    "Starting {startDate}": "{startDate}から開始",
    "Starting today": "本日から開始",
    "State": "",
    "Submit feedback": "フィードバックを送信",
    "Subscribe": "購読する",
    "Subscribed": "購読済み",
    "Subscription plan updated successfully": "",
    "Success": "成功",
    "Success! Check your email for magic link to sign-in.": "成功しました！ログイン用のマジックリンクをメールで確認してください。",
    "Success! Your account is fully activated, you now have access to all content.": "成功しました！アカウントが完全にアクティブ化されました。これですべてのコンテンツにアクセスできます。",
    "Success! Your email is updated.": "成功しました！メールアドレスが更新されました。",
    "Successfully unsubscribed": "正常に購読解除されました",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "購読ありがとうございます。お楽しみになる前に、以下のサイトもおすすめです。",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "フィードバックありがとうございます！",
    "That didn't go to plan": "計画通りにいきませんでした",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "メールアドレスは{memberEmail}です。もし正しくない場合は、<button>アカウント設定</button>で更新することができます。",
    "There was a problem submitting your feedback. Please try again a little later.": "フィードバックの送信中に問題が発生しました。しばらくしてからもう一度お試しください。",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "このサイトは招待制です。アクセスするにはオーナーに連絡してください。",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "This unsubscribe link belongs to a different email address than the one you are signed in with.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "新規登録を完了するには、受信トレイの確認リンクをクリックしてください。3分経っても届かない場合は、スパムフォルダを確認してください。",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "{amount}日間無料でお試しください、その後は{originalPrice}です。",
    "Unable to initiate checkout session": "",
    "Unable to verify your request, please try again": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "有料の購読者になることで、すべてのニュースレターへのアクセスが可能になります。",
    "Unsubscribe from all emails": "すべてのメールの購読解除",
    "Unsubscribed": "購読解除されました",
    "Unsubscribed from all emails.": "すべてのメールの購読を解除する。",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "メールの購読を解除しても、{title}への有料購読はキャンセルされません",
    "Update": "更新",
    "Update your preferences": "設定を更新する",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "確認のためのリンクを送りましたので、受信トレイをチェックしてください",
    "Verify your email address is correct": "メールアドレスが正しいかどうか確認してください",
    "Verifying...": "",
    "View plans": "プランを表示",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "メールアドレスが見つからなかったため、購読解除できませんでした。サイトのオーナーに連絡してください。",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "おかえりなさい、{name}さん！",
    "Welcome back!": "おかえりなさい！",
    "Welcome to {siteTitle}": "{siteTitle}にようこそ",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "受信トレイにメールが届かない場合のことを一般的にバウンスと呼び、多くの場合、一時的なものです。ただし、メールアドレスが無効または存在しない場合、バウンスしたメールは永続的な失敗として返されることがあります。",
    "Why has my email been disabled?": "なぜメールが無効になったのか？",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "年額",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "現在、無料版のメンバーシップです。完全にアクセスするには有料版にアップグレードしてください。",
    "You have been successfully resubscribed": "正常に再購読されました",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "現在、メールを受信していません",
    "You're not receiving emails": "メールを受信していません",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "最近のメッセージをスパムとして判定したか、提供されたメールアドレスに配信できなかったため、メールを受信していません。",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've successfully signed in.": "ログインに成功しました",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "の購読に成功しました <strong>{siteTitle}</strong>",
    "Your account": "あなたのアカウント",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "あなたの感想を今後の内容の参考にさせていただきます。",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "あなたの購読は{expiryDate}に期限切れになります。",
    "Your subscription will renew on {renewalDate}": "あなたの購読は{renewalDate}に更新されます。",
    "Your subscription will start on {subscriptionStart}": "あなたの購読は{subscriptionStart}に開始されます。"
}
